module.exports = __webpack_public_path__ + "img/appAsset-HostedPages--Layout-horizontal.740b64cf.svg";